@let count = entries().length;
@let onboardingActive = onboardingInProgress();
@let guide = currentGuide();

<div
  class="py-2 px-3 bg-white rounded transition-all border-2 border-transparent"
  [class]="
    onboardingActive && guide === StepGuideId.AddContact1 && count === 0
      ? 'border-pulse-enter'
      : ''
  "
>
  <p class="subtitle-2 py-1">
    {{ 'outlook.main.notInMaximizer' | translate: { count: count } }}
  </p>
  @if (loading()) {
    @for (item of [0, 1, 2, 3]; track $index) {
      <div class="space-x-2 flex my-2">
        <maximizer-outlook-skeleton
          containerClasses="h-9 w-9 max-w-9 rounded-full bg-neutral-20"
          fullWidth="none"
        ></maximizer-outlook-skeleton>
        <maximizer-outlook-skeleton
          containerClasses="h-9 w-full rounded-md bg-neutral-20"
        ></maximizer-outlook-skeleton>
      </div>
    }
  } @else {
    <kendo-listview
      [kendoListViewBinding]="entries()"
      [pageable]="pagerSettings()"
      [pageSize]="pageSize()"
      class="border-none main-page"
    >
      <ng-template
        kendoListViewItemTemplate
        let-email="dataItem"
        let-index="index"
      >
        <div class="rounded flex items-center justify-between py-1.5 gap-2">
          <div class="flex gap-2">
            <div
              class="bg-neutral-20 rounded-sm w-8 h-8 flex items-center justify-center"
            >
              <span
                class="fa-icons icon-solid icon-16 icon-user text-white"
              ></span>
            </div>
            <div class="flex flex-col max-w-[180px] smart-word-break">
              <p class="text-body line-clamp-1">
                {{ email.displayName }}
              </p>
              <p class="caption text-neutral-70 line-clamp-1">
                {{ email.emailAddress }}
              </p>
              @if (isTeamMember(email.emailAddress)) {
                <p class="caption text-neutral-70 font-medium">
                  {{ 'outlook.shared.labels.teamMember' | translate }}
                </p>
              }
            </div>
          </div>
          <div class="relative inline-flex">
            @if (
              onboardingActive &&
              (guide === StepGuideId.AddContact1 ||
                (guide === StepGuideId.EntryActions1 &&
                  inMaximizerLength() === 0 &&
                  index === 0))
            ) {
              <span
                class="absolute top-[-3px] left-[-3px] flex h-3 w-3 pointer-events-none z-10"
              >
                <span
                  class="animate-ping absolute inline-flex h-full w-full rounded-full bg-grass-green-120 opacity-75"
                ></span>
                <span
                  class="relative inline-flex rounded-full h-3 w-3 bg-grass-green-120"
                ></span>
              </span>
            }
            <kendo-dropdownbutton
              id="outlook-main-ui-read-createEntry-{{ email.emailAddress }}"
              [title]="'outlook.main.tooltip.add-entry' | translate"
              [data]="addEntryMenuItems()"
              themeColor="primary"
              fillMode="flat"
              iconClass="fa-icons icon-solid icon-16 icon-plus"
              [popupSettings]="{
                appendTo: viewContainerRef,
                popupClass: 'pointer-events-auto'
              }"
              (open)="addEntryDropDownOpen.emit()"
              (close)="addEntryDropDownClose.emit()"
              (itemClick)="onItemClick($event, email)"
              [class.pointer-events-auto]="
                onboardingActive && currentStep() === OnboardingStepNumber.Step1
              "
            >
              <ng-template kendoDropDownButtonItemTemplate let-dataItem>
                <div
                  id="outlook-main-ui-read-add{{ dataItem.id | titlecase }}-{{
                    email.emailAddress
                  }}"
                  class="flex items-center gap-1 w-full"
                  kendoTooltip
                  [tooltipTemplate]="tooltipTemplate"
                  position="top"
                  [callout]="false"
                  [showOn]="dataItem.disabled ? 'hover' : 'none'"
                  [attr.title]="
                    dataItem.disabled
                      ? ('outlook.rights.defaultMessage'
                        | translate
                          : {
                              right: 'outlook.rights.create' | translate,
                              entry:
                                dataItem.id === EntryType.Individual
                                  ? ('individuals' | translateVertical)
                                  : (dataItem.title | translate),
                            })
                      : null
                  "
                >
                  <span [class]="dataItem.icon" class="w-6"></span>
                  <p>
                    @if (dataItem.id === EntryType.Individual) {
                      {{
                        dataItem.text
                          | translate
                            : {
                                label: 'individual' | translateVertical,
                              }
                      }}
                    } @else {
                      {{ dataItem.text | translate }}
                    }
                  </p>
                </div>
              </ng-template>
            </kendo-dropdownbutton>
          </div>
        </div>
      </ng-template>
    </kendo-listview>
  }
</div>

<ng-template #tooltipTemplate let-anchor>
  <p class="caption text-center text-neutral-90 whitespace-nowrap">
    {{ anchor.nativeElement.getAttribute('data-title') }}
  </p>
</ng-template>
